import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    jwt: '',
    name: "",
    headimgurl: "",
    workid:"",
    department:"",
    personid:"",
    phone:"",
    points:"",
    pride:"",
    cardid:""
  },
  mutations: {
    setJwt(state, jwt) {
      state.jwt = jwt;
      // alert("instoreok,jwt="+state.jwt);
      localStorage['jwt'] = jwt;
    },
    setname(state, name) {
      // alert("name is "+ name);
      state.name = name;
      localStorage['name'] = name;
    },
    setheadimgurl(state, headimgurl) {
      state.headimgurl = headimgurl;
      localStorage['headimgurl'] = headimgurl;
    },
    setworkid(state, workid) {
      state.workid = workid;
      localStorage['workid'] = workid;
    },
    setdepartment(state, department) {
      state.department = department;
      localStorage['department'] = department;
    },
    setpersonid(state, personid) {
      state.personid = personid;
      localStorage['personid'] = personid;
    },
    setphone(state, phone) {
      state.phone = phone;
      localStorage['phone'] = phone;
    },
    setpoints(state, points) {
      state.points = points;
      localStorage['points'] = points;
    },
    setpride(state, pride) {
      state.pride = pride;
      localStorage['pride'] = pride;
    },
    setcardid(state, cardid) {
      state.cardid = cardid;
      localStorage['cardid'] = cardid;
    },
    getValueFromLocalStorage() {
      this.state.jwt = localStorage['jwt'];
      this.state.name = localStorage['name'];
      this.state.headimgurl = localStorage['headimgurl'];
      this.state.workid = localStorage['workid'];
      this.state.department = localStorage['department'];
      this.state.personid = localStorage['personid'];
      this.state.phone = localStorage['phone'];
      this.state.points = localStorage['points'];
      this.state.pride = localStorage['pride'];
      this.state.cardid = localStorage['cardid'];
    },
    clearStorage(){
      this.state.jwt = "";
      this.state.name = "";
      this.state.headimgurl = "";
      this.state.workid = "";
      this.state.department = "";
      this.state.personid = "";
      this.state.phone = "";
      this.state.points = "";
      this.state.pride = "";
      this.state.cardid = "";
    },
  },
  actions: {
  },
  modules: {
  }
})




